<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            ajax-path="wideband/tests"
            :ajax-params="ajaxParams"            
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
            @rowSelectionChanged="preview"
        />
        <app-modal 
            width="lg:w-2/3"
            bg="bg-gray-200"
            :show.sync="showPreviewModal"
            @close="showPreviewModal = false"
        >
            <template slot="header">Service Test Details</template>
            <template slot="body">
                <div class="card">
                    <table class="table">
                        <tr>
                            <td><strong>Wideband Test ID</strong></td>
                            <td>
                                <div>{{ test.id }}</div>
                            </td>
                            <td><strong>Status</strong></td>
                            <td>
                                <div>{{ test.status }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Create At</strong></td>
                            <td>
                                <div>{{ test.created_at_for_human }}</div>
                            </td>
                            <td><strong>Updated At</strong></td>
                            <td>
                                <div>{{ test.updated_at_for_human }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Test Type</strong></td>
                            <td>
                                <div>{{ test.test_type }}</div>
                            </td>
                            <td><strong>Test ID</strong></td>
                            <td>
                                <div>{{ test.nbn_test_id }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>NBN AVC ID</strong></td>
                            <td colspan="3">
                                <div>{{ test.nbn_avc_id }}</div>
                            </td>
                        </tr>             
                    </table>
                </div>
                <h2 v-if="test.updates && test.updates.length" class="mt-6 mb-3 font-thin tracking-widest uppercase flex-1">Service Test Updates</h2>
                <tabulator
                    v-if="test.updates && test.updates.length"
                    :data="test.updates"
                    :columns="[
                        {
                            title: 'Created',
                            field: 'created_at_for_human',
                            minWidth: 190,
                        },
                        {
                            title: 'Notification Type',
                            field: 'notification_type',
                            minWidth: 170,
                        }
                    ]"
                    :show-header="false"
                    :show-footer="false"
                />
            </template>
        </app-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import debounce from 'lodash/debounce';

    export default {
        name: 'widebandOutstandingTests',        
        data() {
            return {
                showPreviewModal: false,                
                tableIsLoading: false,
                tableLoadingText: null,
                ajaxParams: {type: 'outstanding'},
                refreshTable: false,
                columns: [
                    {
                        title: 'ID',
                        field: 'id',
                        sorter: 'string',
                        minWidth: 80,
                    },
                    {
                        title: 'Created',
                        field: 'created_at_for_human',
                        sorter: 'string',
                        minWidth: 190,
                    },
                    {
                        title: 'Status',
                        field: 'status',
                        sorter: 'string',
                        minWidth: 110,
                    },
                    {
                        title: 'Type',
                        field: 'test_type',
                        sorter: 'string',
                        minWidth: 140,
                    },                    
                    {
                        title: 'NBN Location ID',
                        field: 'nbn_location_id',
                        sorter: 'string',
                        minWidth: 200,
                    },                    
                    {
                        title: 'NBN AVC ID',
                        field: 'nbn_avc_id',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'NBN PRI ID',
                        field: 'nbn_pri_id',
                        sorter: 'string',
                        minWidth: 200,
                    },                    
                    {
                        title: 'Last Updated',
                        field: 'updated_at_for_human',
                        sorter: 'string',
                        minWidth: 190,
                    }
                ],
                actions: [
                    {
                        label: 'Sync',
                        icon: () => import('@/icons/Sync.vue'),
                        handler: this.sync
                    }
                ],
            }
        },
        computed: {
            ...mapGetters({
                tests: 'wideband/tests/items',
                test: 'wideband/tests/selected'
            })
        },
        methods: {
            preview(tests) {
                if (tests.length) {
                    this.showPreviewModal = true;
                    this.$store.commit('wideband/tests/setSelected', tests[0]);
                }
            },
            sync() {
                this.tableIsLoading = true;
                this.tableLoadingText = 'Syncing...';
                this.$store.dispatch('wideband/tests/sync', 'outstanding')
                    .then(() => {
                        this.tableIsLoading = false;
                        this.refreshTable = true;
                        this.$toast.fire({
                            type: 'success',
                            title: 'Syncing complete.'
                        });
                    })
                    .catch(() => {
                        this.tableIsLoading = false;
                    })
            }
        }
    }
</script>